import _ from 'lodash';


const getErrorFromItemLine = (state) =>{
  return (uuid)=>{
    let line = _.find(state.items, item=>{item.uuid==uuid});
    if(line==null || line.validationErrors.legnth==0)return null;

    return line.validationErrors[0].jse_info.errorCode;
  }
}

const getCreditItemLineTotal = (state) =>{
  let credit = 0;
  _.forEach(state.salesOrder.items, item=>{
    if(item.credit!=null){
      credit+=item.credit;
    }
  })
  return credit;
}

const getAvailableCustomerReservations = (state) => {
  return _.filter(state.customerReservations, r => _.get(r, 'quantity.available') > 0);
}

const getAvailableRepAllocation = (state) => {
  return _.filter(state.repAllocations, r => _.get(r, 'quantity.available') > 0);
}



export default {
  getErrorFromItemLine,
  getCreditItemLineTotal,
  getAvailableCustomerReservations,
  getAvailableRepAllocation
};
